import { useCallback } from 'react';

import { useDialogs } from '@toolpad/core/useDialogs';

import Confirmation from './Confirmation';
import { ConfirmationDialogPayload } from './types';

function useConfirmationDialog(DialogComponent = Confirmation) {
  const dialog = useDialogs();

  return useCallback(
    (payload: ConfirmationDialogPayload) => dialog.open(DialogComponent, payload),
    [dialog, DialogComponent],
  );
}

export { Confirmation };
export default useConfirmationDialog;
